/* eslint-disable react/prop-types */
// @ts-nocheck
import React, { useCallback } from 'react';
import { Box, Popover, TextField } from '@mui/material';
import DocTree from './DocTree';
import { SwalToast } from '../Common';

/**
 * @function findId
 * @description A function to find id of node
 * @param {number} id - id of node
 * @param {array} arr - array of nodes
 */

function findId(id, arr) {
  // eslint-disable-next-line array-callback-return
  return arr?.reduce((a, item) => {
    if (a) {
      return a;
    }
    if (item?.node_id === id) {
      return item;
    }
    if (item?.child) {
      return findId(id, item?.child);
    }
  }, null);
}
// eslint-disable-next-line react/prop-types

/**
 * @function DocTreeDropdown
 * @description A function component that renders a dropdown of DocTree
 * @param {string} name - name of dropdown
 * @param {object} docEditorOverview - object of docEditorOverview
 * @param {string} label - label of dropdown
 * @param {string} placeholder - placeholder of dropdown
 * @param {function} onNodeSelect - function to handle node selection
 * @param {object} defaultValue - default value of dropdown
 */

const DocTreeDropdown = ({
  name,
  docEditorOverview,
  label,
  placeholder,
  onNodeSelect,
  defaultValue,
}) => {
  const ref = React.useRef();
  const [open, setOpen] = React.useState(false);
  const [selectedNode, setSelectedNode] = React.useState();
  const [value, setValue] = React.useState();

  React.useEffect(() => {
    if (selectedNode?.parent) {
      const parentObj = findId(selectedNode?.parent, docEditorOverview?.child);
      const str = `${
        parentObj?.node_heading
          ? parentObj?.node_heading
          : parentObj?.node_content
      } / ${findId(selectedNode?.id, docEditorOverview?.child)?.node_heading}`;
      if (
        str ===
        `${
          parentObj?.node_heading
            ? parentObj?.node_heading
            : parentObj?.node_content
        } / undefined`
      ) {
        setValue(
          parentObj?.node_heading
            ? parentObj?.node_heading
            : parentObj?.node_content
        );
      } else {
        setValue(str);
      }
    }

    if (defaultValue?.parent && !selectedNode?.parent) {
      const parentObj = findId(defaultValue?.parent, docEditorOverview?.child);
      const str = `${
        parentObj?.node_heading
          ? parentObj?.node_heading
          : parentObj?.node_content
      } / ${findId(defaultValue?.id, docEditorOverview?.child)?.node_heading}`;

      if (
        str ===
        `${
          parentObj?.node_heading
            ? parentObj?.node_heading
            : parentObj?.node_content
        } / undefined`
      ) {
        setValue(
          parentObj?.node_heading
            ? parentObj?.node_heading
            : parentObj?.node_content
        );
      } else {
        setValue(str);
      }
    }
  }, [selectedNode, docEditorOverview, ref, defaultValue]);
  /**
   * @function handleClose
   * @description to handle close
   * @returns {void}
   * @example handleClose()
   */
  const handleClose = () => {
    if (value === 'undefined / undefined') {
      SwalToast({
        icon: 'error',
        title: 'Please select node. Only section selection is not allowed.',
      });
    } else {
      setOpen(false);
    }
  };

  const textFieldonClick = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const popoveronClose = useCallback(() => {
    handleClose();
  }, [handleClose]);

  const docTreegetSelectedID = useCallback(
    (val) => {
      onNodeSelect(val);
      setSelectedNode(val);
      if (val?.parent !== -1) {
        setOpen(false);
      }
    },
    [onNodeSelect, setSelectedNode]
  );

  return (
    <>
      <TextField
        label={label}
        placeholder={placeholder}
        name={name}
        inputProps={{ readOnly: true }}
        value={value}
        onClick={textFieldonClick}
        ref={ref}
      />
      <Popover
        open={open}
        anchorEl={ref?.current}
        onClose={popoveronClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        keepMounted={true}
      >
        <Box sx={{ minWidth: '200px', width: '100%' }} p={2}>
          {docEditorOverview && (
            <Box>
              {
                // eslint-disable-next-line react/prop-types
                docEditorOverview?.child?.length > 0 ? (
                  <Box
                    sx={{
                      width: 'auto',
                      height: 250,
                      overflow: 'scroll',
                    }}
                  >
                    <DocTree
                      data={{
                        node_id: 'root',
                        node_type: 'root',
                        // eslint-disable-next-line react/prop-types
                        child: docEditorOverview?.child,
                      }}
                      getSelectedID={docTreegetSelectedID}
                    />
                  </Box>
                ) : (
                  <Box textAlign="center">
                    No section available in this document
                  </Box>
                )
              }
            </Box>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default DocTreeDropdown;
